<template>
  <div class="tw:px-4 tw:mb-8 tw:flex tw:flex-col tw:lg:flex-row tw:items-start tw:justify-between tw:gap-y-8">
    <div class="tw:flex tw:flex-col">
      <h3 class="tw:text-2xl tw:font-bold tw:mb-3">{{ $t('rc_smartboost_benefit_header') }}</h3>
      <p>
        {{ $t('rc_smartboost_subtext') }}
      </p>
    </div>
    <GhostButton
      class="icon-btn tw:flex tw:gap-x-2 tw:items-center tw:justify-center tw:mb-4 tw:md:mb-0 tw:group-hover:fill-white"
      @click="openVideo"
    >
      <PlayIcon class="tw:fill-gray-800 tw:mr-2" />
      {{ $t('rc_smartboost_video_cta') }}
    </GhostButton>
  </div>
</template>
<script setup>
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import PlayIcon from '@/components/icons/PlayIcon.svg?component'

const emit = defineEmits(['openVideo'])
const openVideo = () => emit('openVideo')
</script>
